import styled from 'styled-components/macro'
import { caption } from 'styles/mixins/textstyles'

const Step = styled.p`
  ${(props) => caption(props.theme.colors.black, 'medium')}
  padding-top: .8rem;
`

export default Step
